// import $ from 'jquery';

export default class {
  static isPc() {
    var flg = false;
    if (window.matchMedia('(max-width: 768px)').matches) {
      // console.log('SP');
    } else {
      // console.log('PC');
      flg = true;
    }
    return flg;
  }
}
